// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * PaymentLinks.css — responsive overrides for src/pages/PaymentLinks.jsx
 * Loads after index.css (imported as FIRST css import in PaymentLinks.jsx) so
 * wins at equal specificity.
 * Breakpoints: mobile <=576px, tablet 577-991px, laptop 992-1280px, desktop >=1281px.
 * Desktop behaviour is UNCHANGED — all rules are inside max-width media queries.
 */

/* ═══════════════════════════════════════════════════════════════════════════
 * REDESIGN RESKIN (light design system) — page-scoped, consumes redesign.css
 * tokens. Loads after index.css so these win by source order at equal/higher
 * specificity. Visual only — no behavior change. Class names are unchanged;
 * we restyle the existing markup of PaymentLinks.jsx to the new language.
 * Scopes: .payment-links-page (list) + .payment-link-detail-page (detail).
 * ════════════════════════════════════════════════════════════════════════ */

/* ---- Page header ---- */
.payment-links-page .page-header h1,
.payment-link-detail-page .page-header h1 {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.payment-links-page .page-header p,
.payment-link-detail-page .page-header p {
  font-size: 0.875rem;
  color: var(--ink-secondary);
}

/* "View API Documentation" -> black primary button */
.payment-links-page .mode-btn-purple {
  background: var(--primary);
  color: #fff;
  border: 1px solid var(--primary);
  border-radius: var(--r-sm);
  padding: 9px 16px;
  font-size: 0.875rem;
  font-weight: 600;
}
.payment-links-page .mode-btn-purple:hover {
  background: var(--primary-hover);
}

/* Merchant filter (admin) */
.payment-links-page .merchant-filter {
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  background: var(--bg-surface);
  color: var(--ink);
  box-shadow: var(--sh-sm);
}
.payment-links-page .merchant-filter:hover,
.payment-links-page .merchant-filter:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

/* ---- Stat items (KPI strip) ---- */
.payment-links-page .stats-row .stat-item,
.payment-link-detail-page .stats-row .stat-item {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-sm);
  padding: 16px 20px;
}
.payment-links-page .stats-row .stat-label,
.payment-link-detail-page .stats-row .stat-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--ink-muted);
}
.payment-links-page .stats-row .stat-value,
.payment-link-detail-page .stats-row .stat-value {
  font-family: var(--font-mono);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
}

/* ---- Cards / sections ---- */
.payment-links-page .card,
.payment-link-detail-page .card,
.payment-link-detail-page .detail-section {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-sm);
}
.payment-link-detail-page .section-title,
.payment-links-page .section-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
}
.payment-link-detail-page .section-title[style] {
  border-bottom-color: var(--line) !important;
}

/* ---- Back button ---- */
.payment-link-detail-page .back-btn {
  color: var(--ink-secondary);
  font-weight: 600;
}
.payment-link-detail-page .back-btn:hover {
  color: var(--ink);
}

/* ---- Detail header ---- */
.payment-link-detail-page .detail-label {
  color: var(--ink-muted);
}
.payment-link-detail-page .detail-title {
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
}
.payment-link-detail-page .detail-subtitle {
  color: var(--ink-muted);
}

/* ---- Detail rows ---- */
.payment-link-detail-page .detail-row {
  border-bottom-color: var(--line);
}
.payment-link-detail-page .detail-key {
  color: var(--ink-secondary);
}
.payment-link-detail-page .detail-value {
  color: var(--ink);
}
.payment-link-detail-page .detail-value.mono,
.payment-link-detail-page .detail-value[style*="monospace"] {
  font-family: var(--font-mono);
}

/* ---- Info cards (API key / webhook / link id) ---- */
.payment-link-detail-page .info-card {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-sm);
}
.payment-link-detail-page .info-card-header {
  color: var(--ink-muted);
  font-weight: 600;
}
.payment-link-detail-page .info-card-content code {
  background: var(--bg-inset);
  color: var(--ink);
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-family: var(--font-mono);
}

/* ---- Status badges (dot + label) ---- */
.payment-links-page .status-badge,
.payment-link-detail-page .status-badge,
.payment-link-detail-page .status-badge-large {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: var(--r-pill);
  font-weight: 600;
}
.payment-links-page .status-badge::before,
.payment-link-detail-page .status-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.payment-links-page .status-badge.active,
.payment-links-page .status-badge.completed,
.payment-links-page .status-badge.paid,
.payment-link-detail-page .status-badge.active,
.payment-link-detail-page .status-badge-large.active {
  background: var(--ok-soft);
  color: var(--ok);
}
.payment-links-page .status-badge.pending,
.payment-link-detail-page .status-badge.pending {
  background: var(--warn-soft);
  color: var(--warn);
}
.payment-links-page .status-badge.inactive,
.payment-links-page .status-badge.failed,
.payment-links-page .status-badge.cancelled,
.payment-link-detail-page .status-badge.inactive,
.payment-link-detail-page .status-badge.failed,
.payment-link-detail-page .status-badge-large.inactive {
  background: var(--err-soft);
  color: var(--err);
}
.payment-links-page .status-badge.draft {
  background: var(--bg-inset);
  color: var(--ink-muted);
}

/* ---- API key cell (mono) + row actions ---- */
.payment-links-page .api-key-value {
  font-family: var(--font-mono);
  color: var(--ink);
}
.payment-links-page .action-icon-btn {
  color: var(--ink-muted);
  border-radius: var(--r-sm);
}
.payment-links-page .action-icon-btn:hover {
  background: var(--bg-inset);
  color: var(--ink);
}
.payment-links-page .action-icon-btn.danger:hover {
  background: var(--err-soft);
  color: var(--err);
}
.payment-links-page .link-name,
.payment-link-detail-page .link-name {
  color: var(--ink);
  font-weight: 600;
}
.payment-links-page .link-description,
.payment-links-page .link-id,
.payment-link-detail-page .link-description,
.payment-link-detail-page .link-id {
  color: var(--ink-muted);
}

/* ---- Row dropdown menu ---- */
.payment-links-page .action-dropdown-menu {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  box-shadow: var(--sh-pop);
}
.payment-links-page .action-dropdown-menu .dropdown-item {
  color: var(--ink);
}
.payment-links-page .action-dropdown-menu .dropdown-item:hover {
  background: var(--bg-inset);
}
.payment-links-page .action-dropdown-menu .dropdown-item.danger {
  color: var(--err);
}

/* ---- Buttons (page-scoped) ---- */
.payment-links-page .btn-primary,
.payment-link-detail-page .btn-primary {
  background: var(--primary);
  border: 1px solid var(--primary);
  border-radius: var(--r-sm);
  font-weight: 600;
}
.payment-links-page .btn-primary:hover:not(:disabled),
.payment-link-detail-page .btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  transform: none;
  box-shadow: none;
}
.payment-links-page .btn-secondary,
.payment-link-detail-page .btn-secondary {
  background: var(--bg-surface);
  color: var(--ink);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  box-shadow: var(--sh-sm);
  font-weight: 600;
}
.payment-links-page .btn-secondary:hover,
.payment-link-detail-page .btn-secondary:hover {
  background: var(--bg-inset);
  border-color: var(--line-strong);
}
.payment-link-detail-page .btn-icon,
.payment-link-detail-page .btn-icon.small {
  background: var(--bg-surface);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  color: var(--ink-secondary);
}
.payment-link-detail-page .btn-icon:hover,
.payment-link-detail-page .btn-icon.small:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--bg-inset);
}

/* ---- Drawers ---- */
.payment-links-page .drawer,
.payment-link-detail-page .drawer {
  background: var(--bg-surface);
}
.payment-links-page .drawer-header,
.payment-link-detail-page .drawer-header {
  border-bottom-color: var(--line);
}
.payment-links-page .drawer-header h2,
.payment-link-detail-page .drawer-header h2 {
  color: var(--ink);
  font-weight: 700;
}
.payment-links-page .drawer-footer,
.payment-link-detail-page .drawer-footer {
  border-top-color: var(--line);
}
.payment-links-page .drawer-info,
.payment-link-detail-page .drawer-info {
  color: var(--ink-secondary);
}
.payment-links-page .drawer-close-btn,
.payment-link-detail-page .drawer-close-btn {
  color: var(--ink-muted);
}
.payment-links-page .drawer-section-title,
.payment-link-detail-page .drawer-section-title {
  color: var(--ink);
  font-weight: 700;
}

/* ---- Forms inside drawers ---- */
.payment-links-page .form-group label,
.payment-link-detail-page .form-group label {
  color: var(--ink);
  font-weight: 600;
}
.payment-links-page .form-group input,
.payment-links-page .form-group textarea,
.payment-link-detail-page .form-group input,
.payment-link-detail-page .form-group textarea {
  background: var(--bg-surface);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  color: var(--ink);
}
.payment-links-page .form-group input:focus,
.payment-links-page .form-group textarea:focus,
.payment-link-detail-page .form-group input:focus,
.payment-link-detail-page .form-group textarea:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
  outline: none;
}
.payment-links-page .form-hint,
.payment-link-detail-page .form-hint {
  color: var(--ink-muted);
}

/* ---- Info box (usage hint) ---- */
.payment-links-page .info-box,
.payment-link-detail-page .info-box {
  background: var(--accent-soft);
  border: 1px solid var(--accent);
  border-radius: var(--r-md);
}
.payment-links-page .info-box h4,
.payment-link-detail-page .info-box h4 {
  color: var(--accent-ink);
}
.payment-links-page .info-box ol,
.payment-link-detail-page .info-box ol {
  color: var(--ink-secondary);
}
.payment-links-page .info-box code,
.payment-link-detail-page .info-box code {
  background: var(--bg-surface);
  color: var(--accent-ink);
  font-family: var(--font-mono);
}

/* ---- Integration guide drawer: code blocks (dark) ---- */
.payment-links-page .usage-guide-content .code-content,
.payment-links-page .usage-guide-content .response-example {
  background: #1a1a1e;
  color: #e4e4e7;
  border-radius: var(--r-md);
  font-family: var(--font-mono);
}
.payment-links-page .usage-guide-content .code-example {
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  overflow: hidden;
}
.payment-links-page .usage-guide-content .code-example-header,
.payment-links-page .usage-guide-content .code-block .code-header {
  background: var(--bg-subtle);
  border-bottom: 1px solid var(--line);
}
.payment-links-page .usage-guide-content .copy-btn {
  background: var(--bg-surface);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-sm);
  color: var(--ink-secondary);
}
.payment-links-page .usage-guide-content .endpoint {
  font-family: var(--font-mono);
  color: var(--ink);
}
.payment-links-page .usage-guide-content .method.post {
  background: var(--info-soft);
  color: var(--info);
}
.payment-links-page .usage-guide-content .param-name {
  background: var(--accent-soft);
  color: var(--accent-ink);
  font-family: var(--font-mono);
}
.payment-links-page .usage-guide-content .param-required {
  color: var(--err);
}
.payment-links-page .usage-guide-content .param-optional {
  color: var(--ink-muted);
}
.payment-links-page .usage-guide-content .security-item {
  background: var(--bg-subtle);
  border-radius: var(--r-md);
}
.payment-links-page .usage-guide-content .guide-section-header h3 {
  color: var(--ink);
  font-weight: 700;
}
.payment-links-page .usage-guide-content .guide-section-header svg {
  color: var(--accent);
}
.payment-links-page .usage-guide-content .step-number {
  background: var(--accent-soft);
  color: var(--accent-ink);
}

/* ---- Confirm modal (delete/revoke) ---- */
.payment-links-page .confirm-modal {
  background: var(--bg-surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-pop);
}

/* ---- Session drawer tx items ---- */
.payment-link-detail-page .session-transaction-item {
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  background: var(--bg-subtle);
}
.payment-link-detail-page .tx-value.mono,
.payment-link-detail-page .detail-value.mono {
  font-family: var(--font-mono);
}
.payment-link-detail-page .metadata-block {
  background: #1a1a1e;
  color: #e4e4e7;
  border-radius: var(--r-md);
  font-family: var(--font-mono);
}

/* ─── Tablet (≤991px) ──────────────────────────────────────────────────────── */
@media (max-width: 991px) {
  /* Page header: wrap header actions so the doc-link button doesn't overflow */
  .payment-links-page .page-header {
    flex-wrap: wrap;
    gap: 12px;
  }

  .payment-links-page .header-actions {
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
  }

  /* Stats row: 2 items per row on tablet */
  .payment-links-page .stats-row {
    flex-wrap: wrap;
  }

  .payment-links-page .stats-row .stat-item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
    min-width: 120px;
  }

  /* Detail header: allow stacking when status badge + title are side by side */
  .payment-link-detail-page .detail-header {
    flex-wrap: wrap;
    gap: 12px;
  }
}

/* ─── Mobile (≤576px) ─────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  /* ── Page root: prevent horizontal scroll ── */
  .payment-links-page,
  .payment-link-detail-page {
    min-width: 0;
    overflow-x: hidden;
  }

  /* ── Page header: stack title + actions vertically ── */
  .payment-links-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
  }

  .payment-links-page .page-header h1 {
    font-size: 1.25rem;
  }

  .payment-links-page .page-header p {
    font-size: 0.8125rem;
  }

  .payment-links-page .header-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    width: 100%;
  }

  /* Merchant filter: full-width on mobile */
  .payment-links-page .merchant-filter {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    box-sizing: border-box;
  }

  /* View API Docs button: full-width, 44px tap target */
  .payment-links-page .mode-btn-purple {
    width: 100%;
    justify-content: center;
    min-height: 44px;
    text-align: center;
    box-sizing: border-box;
  }

  /* ── Stats row: single column ── */
  .payment-links-page .stats-row {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  .payment-links-page .stats-row .stat-item {
    flex: none;
    width: 100%;
    min-height: 44px;
    padding: 12px 16px;
  }

  /* Prevent the DataTable overflow:scroll from forcing horizontal page scroll */
  .payment-links-page .card .data-table-container {
    overflow-x: auto;
    max-width: 100%;
  }

  /* ── Detail page: back button is already 44px-friendly; add padding ── */
  .payment-link-detail-page .back-btn {
    min-height: 44px;
    padding: 10px 0;
  }

  /* ── Detail header: stack left+right vertically ── */
  .payment-link-detail-page .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .payment-link-detail-page .detail-title {
    font-size: 1.25rem;
    word-break: break-word;
  }

  /* ── Page header inside detail views ── */
  .payment-link-detail-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 16px;
  }

  .payment-link-detail-page .page-header h1 {
    font-size: 1.25rem;
  }

  /* "Create Payment Link" button in the payment-links detail view */
  .payment-link-detail-page .page-header .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Info cards row: force single column ── */
  .payment-link-detail-page .info-cards-row,
  .payment-links-page .info-cards-row {
    grid-template-columns: 1fr;
    gap: 8px;
    margin-bottom: 16px;
  }

  /* Code values inside info-cards wrap rather than overflow */
  .info-card-content code {
    font-size: 11px;
    word-break: break-all;
    overflow-x: hidden;
  }

  /* ── Stats row in detail view (Transaction counts) ── */
  .payment-link-detail-page .stats-row {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  .payment-link-detail-page .stats-row .stat-item {
    flex: none;
    width: 100%;
    min-height: 44px;
  }

  /* ── Section title inside card (used inline) ── */
  .payment-link-detail-page .section-title {
    font-size: 0.9375rem;
  }

  /* ── Detail rows: stack key-value vertically when value is long (addresses, hashes) ── */
  .payment-link-detail-page .detail-row {
    flex-wrap: wrap;
    gap: 4px;
  }

  .payment-link-detail-page .detail-value {
    text-align: left;
    word-break: break-all;
    max-width: 100%;
  }

  /* ── Session status banner: stack status + amount ── */
  .session-status-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 16px;
  }

  .session-amount-large {
    font-size: 1.25rem;
  }

  /* ── Drawer: use dynamic viewport height so the footer (primary action)
        stays inside the visible viewport when the mobile browser chrome is
        shown — plain 100vh can push the footer below the fold. ── */
  .payment-links-page .drawer,
  .payment-link-detail-page .drawer {
    height: 100vh;
    height: 100dvh;
  }

  /* ── Drawer close button: 44px tap target ── */
  .drawer-close-btn {
    min-width: 44px;
    min-height: 44px;
  }

  /* ── Drawer footer buttons: stack vertically, full width ── */
  .drawer-footer {
    flex-direction: column;
    gap: 8px;
  }

  .drawer-footer .btn-primary,
  .drawer-footer .btn-secondary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Confirm modal → bottom sheet on mobile ── */
  .confirm-modal {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    width: 100%;
    max-width: 100%;
    border-radius: 16px 16px 0 0;
    padding: 24px 20px;
    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
    animation: pl-sheet-up 0.25s ease-out;
    max-height: 85dvh;
    max-height: 85vh;
    overflow-y: auto;
    z-index: 1001;
  }

  @keyframes pl-sheet-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  .confirm-modal-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .confirm-modal-actions button {
    flex: none;
    width: 100%;
    min-height: 44px;
  }

  /* ── API key cell: wrap key + icon buttons ── */
  .api-key-cell {
    flex-wrap: wrap;
    gap: 4px;
    max-width: 100%;
  }

  .api-key-cell .api-key-value {
    word-break: break-all;
    font-size: 11px;
    min-width: 0;
    flex: 1 1 100%;
  }

  /* Action icon buttons: ensure 44px tap target */
  .action-icon-btn {
    min-width: 36px;
    min-height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Security table in guide drawer: horizontal scroll rather than breaking layout ── */
  .security-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }

  /* ── Code blocks in guide drawer: scroll, don't break page ── */
  .code-content,
  .response-example {
    font-size: 11px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* ── Guide steps: consistent padding ── */
  .guide-section {
    padding: 16px;
  }

  .guide-step {
    gap: 12px;
  }

  /* ── Empty payments section: reduce padding ── */
  .empty-payments-section {
    padding: 24px 16px;
  }

  .empty-payments-section .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Session transaction items in drawer: comfortable tap/read areas ── */
  .session-transaction-item {
    padding: 12px;
  }

  .tx-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  /* ── Session detail: mono values wrap ── */
  .detail-value.mono {
    word-break: break-all;
    font-size: 11px;
  }

  /* ── "View Transactions" button in payment link detail ── */
  .detail-section .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/PaymentLinks.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;;;;;;6EAM6E;;AAE7E,0BAA0B;AAC1B;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,0BAA0B;EAC1B,WAAW;EACX,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;;EAEE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;;;EAGE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,0CAA0C;AAC1C;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;;;;;EAKE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;;;;;;EAME,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;;EAEE,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;;;;EAIE,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;AACf;AACA;;EAEE,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA,2DAA2D;AAC3D;;EAEE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;EAEE,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,iFAAiF;AACjF;EACE,6EAA6E;EAC7E;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,WAAW;EACb;;EAEA,yCAAyC;EACzC;IACE,eAAe;EACjB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,gBAAgB;EAClB;;EAEA,6EAA6E;EAC7E;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,gFAAgF;AAChF;EACE,+CAA+C;EAC/C;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;IACR,WAAW;EACb;;EAEA,0CAA0C;EAC1C;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,sDAAsD;EACtD;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,8EAA8E;EAC9E;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,yEAAyE;EACzE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,qDAAqD;EACrD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,0CAA0C;EAC1C;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,kEAAkE;EAClE;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;;IAEE,0BAA0B;IAC1B,QAAQ;IACR,mBAAmB;EACrB;;EAEA,4DAA4D;EAC5D;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;IACE,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA,kDAAkD;EAClD;IACE,oBAAoB;EACtB;;EAEA,yFAAyF;EACzF;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;;EAEA,uDAAuD;EACvD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;oEAEkE;EAClE;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,8DAA8D;EAC9D;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,6DAA6D;IAC7D,qCAAqC;IACrC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA,gDAAgD;EAChD;IACE,eAAe;IACf,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA,gDAAgD;EAChD;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,wFAAwF;EACxF;IACE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;EACb;;EAEA,gEAAgE;EAChE;;IAEE,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA,iDAAiD;EACjD;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,0EAA0E;EAC1E;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA,2CAA2C;EAC3C;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA,4DAA4D;EAC5D;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * PaymentLinks.css — responsive overrides for src/pages/PaymentLinks.jsx\n * Loads after index.css (imported as FIRST css import in PaymentLinks.jsx) so\n * wins at equal specificity.\n * Breakpoints: mobile <=576px, tablet 577-991px, laptop 992-1280px, desktop >=1281px.\n * Desktop behaviour is UNCHANGED — all rules are inside max-width media queries.\n */\n\n/* ═══════════════════════════════════════════════════════════════════════════\n * REDESIGN RESKIN (light design system) — page-scoped, consumes redesign.css\n * tokens. Loads after index.css so these win by source order at equal/higher\n * specificity. Visual only — no behavior change. Class names are unchanged;\n * we restyle the existing markup of PaymentLinks.jsx to the new language.\n * Scopes: .payment-links-page (list) + .payment-link-detail-page (detail).\n * ════════════════════════════════════════════════════════════════════════ */\n\n/* ---- Page header ---- */\n.payment-links-page .page-header h1,\n.payment-link-detail-page .page-header h1 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n.payment-links-page .page-header p,\n.payment-link-detail-page .page-header p {\n  font-size: 0.875rem;\n  color: var(--ink-secondary);\n}\n\n/* \"View API Documentation\" -> black primary button */\n.payment-links-page .mode-btn-purple {\n  background: var(--primary);\n  color: #fff;\n  border: 1px solid var(--primary);\n  border-radius: var(--r-sm);\n  padding: 9px 16px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n.payment-links-page .mode-btn-purple:hover {\n  background: var(--primary-hover);\n}\n\n/* Merchant filter (admin) */\n.payment-links-page .merchant-filter {\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-sm);\n  background: var(--bg-surface);\n  color: var(--ink);\n  box-shadow: var(--sh-sm);\n}\n.payment-links-page .merchant-filter:hover,\n.payment-links-page .merchant-filter:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n/* ---- Stat items (KPI strip) ---- */\n.payment-links-page .stats-row .stat-item,\n.payment-link-detail-page .stats-row .stat-item {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-sm);\n  padding: 16px 20px;\n}\n.payment-links-page .stats-row .stat-label,\n.payment-link-detail-page .stats-row .stat-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--ink-muted);\n}\n.payment-links-page .stats-row .stat-value,\n.payment-link-detail-page .stats-row .stat-value {\n  font-family: var(--font-mono);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n\n/* ---- Cards / sections ---- */\n.payment-links-page .card,\n.payment-link-detail-page .card,\n.payment-link-detail-page .detail-section {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-sm);\n}\n.payment-link-detail-page .section-title,\n.payment-links-page .section-title {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n}\n.payment-link-detail-page .section-title[style] {\n  border-bottom-color: var(--line) !important;\n}\n\n/* ---- Back button ---- */\n.payment-link-detail-page .back-btn {\n  color: var(--ink-secondary);\n  font-weight: 600;\n}\n.payment-link-detail-page .back-btn:hover {\n  color: var(--ink);\n}\n\n/* ---- Detail header ---- */\n.payment-link-detail-page .detail-label {\n  color: var(--ink-muted);\n}\n.payment-link-detail-page .detail-title {\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--ink);\n}\n.payment-link-detail-page .detail-subtitle {\n  color: var(--ink-muted);\n}\n\n/* ---- Detail rows ---- */\n.payment-link-detail-page .detail-row {\n  border-bottom-color: var(--line);\n}\n.payment-link-detail-page .detail-key {\n  color: var(--ink-secondary);\n}\n.payment-link-detail-page .detail-value {\n  color: var(--ink);\n}\n.payment-link-detail-page .detail-value.mono,\n.payment-link-detail-page .detail-value[style*=\"monospace\"] {\n  font-family: var(--font-mono);\n}\n\n/* ---- Info cards (API key / webhook / link id) ---- */\n.payment-link-detail-page .info-card {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-sm);\n}\n.payment-link-detail-page .info-card-header {\n  color: var(--ink-muted);\n  font-weight: 600;\n}\n.payment-link-detail-page .info-card-content code {\n  background: var(--bg-inset);\n  color: var(--ink);\n  border: 1px solid var(--line);\n  border-radius: var(--r-sm);\n  font-family: var(--font-mono);\n}\n\n/* ---- Status badges (dot + label) ---- */\n.payment-links-page .status-badge,\n.payment-link-detail-page .status-badge,\n.payment-link-detail-page .status-badge-large {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: var(--r-pill);\n  font-weight: 600;\n}\n.payment-links-page .status-badge::before,\n.payment-link-detail-page .status-badge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.payment-links-page .status-badge.active,\n.payment-links-page .status-badge.completed,\n.payment-links-page .status-badge.paid,\n.payment-link-detail-page .status-badge.active,\n.payment-link-detail-page .status-badge-large.active {\n  background: var(--ok-soft);\n  color: var(--ok);\n}\n.payment-links-page .status-badge.pending,\n.payment-link-detail-page .status-badge.pending {\n  background: var(--warn-soft);\n  color: var(--warn);\n}\n.payment-links-page .status-badge.inactive,\n.payment-links-page .status-badge.failed,\n.payment-links-page .status-badge.cancelled,\n.payment-link-detail-page .status-badge.inactive,\n.payment-link-detail-page .status-badge.failed,\n.payment-link-detail-page .status-badge-large.inactive {\n  background: var(--err-soft);\n  color: var(--err);\n}\n.payment-links-page .status-badge.draft {\n  background: var(--bg-inset);\n  color: var(--ink-muted);\n}\n\n/* ---- API key cell (mono) + row actions ---- */\n.payment-links-page .api-key-value {\n  font-family: var(--font-mono);\n  color: var(--ink);\n}\n.payment-links-page .action-icon-btn {\n  color: var(--ink-muted);\n  border-radius: var(--r-sm);\n}\n.payment-links-page .action-icon-btn:hover {\n  background: var(--bg-inset);\n  color: var(--ink);\n}\n.payment-links-page .action-icon-btn.danger:hover {\n  background: var(--err-soft);\n  color: var(--err);\n}\n.payment-links-page .link-name,\n.payment-link-detail-page .link-name {\n  color: var(--ink);\n  font-weight: 600;\n}\n.payment-links-page .link-description,\n.payment-links-page .link-id,\n.payment-link-detail-page .link-description,\n.payment-link-detail-page .link-id {\n  color: var(--ink-muted);\n}\n\n/* ---- Row dropdown menu ---- */\n.payment-links-page .action-dropdown-menu {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  box-shadow: var(--sh-pop);\n}\n.payment-links-page .action-dropdown-menu .dropdown-item {\n  color: var(--ink);\n}\n.payment-links-page .action-dropdown-menu .dropdown-item:hover {\n  background: var(--bg-inset);\n}\n.payment-links-page .action-dropdown-menu .dropdown-item.danger {\n  color: var(--err);\n}\n\n/* ---- Buttons (page-scoped) ---- */\n.payment-links-page .btn-primary,\n.payment-link-detail-page .btn-primary {\n  background: var(--primary);\n  border: 1px solid var(--primary);\n  border-radius: var(--r-sm);\n  font-weight: 600;\n}\n.payment-links-page .btn-primary:hover:not(:disabled),\n.payment-link-detail-page .btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  transform: none;\n  box-shadow: none;\n}\n.payment-links-page .btn-secondary,\n.payment-link-detail-page .btn-secondary {\n  background: var(--bg-surface);\n  color: var(--ink);\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-sm);\n  box-shadow: var(--sh-sm);\n  font-weight: 600;\n}\n.payment-links-page .btn-secondary:hover,\n.payment-link-detail-page .btn-secondary:hover {\n  background: var(--bg-inset);\n  border-color: var(--line-strong);\n}\n.payment-link-detail-page .btn-icon,\n.payment-link-detail-page .btn-icon.small {\n  background: var(--bg-surface);\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-sm);\n  color: var(--ink-secondary);\n}\n.payment-link-detail-page .btn-icon:hover,\n.payment-link-detail-page .btn-icon.small:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: var(--bg-inset);\n}\n\n/* ---- Drawers ---- */\n.payment-links-page .drawer,\n.payment-link-detail-page .drawer {\n  background: var(--bg-surface);\n}\n.payment-links-page .drawer-header,\n.payment-link-detail-page .drawer-header {\n  border-bottom-color: var(--line);\n}\n.payment-links-page .drawer-header h2,\n.payment-link-detail-page .drawer-header h2 {\n  color: var(--ink);\n  font-weight: 700;\n}\n.payment-links-page .drawer-footer,\n.payment-link-detail-page .drawer-footer {\n  border-top-color: var(--line);\n}\n.payment-links-page .drawer-info,\n.payment-link-detail-page .drawer-info {\n  color: var(--ink-secondary);\n}\n.payment-links-page .drawer-close-btn,\n.payment-link-detail-page .drawer-close-btn {\n  color: var(--ink-muted);\n}\n.payment-links-page .drawer-section-title,\n.payment-link-detail-page .drawer-section-title {\n  color: var(--ink);\n  font-weight: 700;\n}\n\n/* ---- Forms inside drawers ---- */\n.payment-links-page .form-group label,\n.payment-link-detail-page .form-group label {\n  color: var(--ink);\n  font-weight: 600;\n}\n.payment-links-page .form-group input,\n.payment-links-page .form-group textarea,\n.payment-link-detail-page .form-group input,\n.payment-link-detail-page .form-group textarea {\n  background: var(--bg-surface);\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-sm);\n  color: var(--ink);\n}\n.payment-links-page .form-group input:focus,\n.payment-links-page .form-group textarea:focus,\n.payment-link-detail-page .form-group input:focus,\n.payment-link-detail-page .form-group textarea:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n  outline: none;\n}\n.payment-links-page .form-hint,\n.payment-link-detail-page .form-hint {\n  color: var(--ink-muted);\n}\n\n/* ---- Info box (usage hint) ---- */\n.payment-links-page .info-box,\n.payment-link-detail-page .info-box {\n  background: var(--accent-soft);\n  border: 1px solid var(--accent);\n  border-radius: var(--r-md);\n}\n.payment-links-page .info-box h4,\n.payment-link-detail-page .info-box h4 {\n  color: var(--accent-ink);\n}\n.payment-links-page .info-box ol,\n.payment-link-detail-page .info-box ol {\n  color: var(--ink-secondary);\n}\n.payment-links-page .info-box code,\n.payment-link-detail-page .info-box code {\n  background: var(--bg-surface);\n  color: var(--accent-ink);\n  font-family: var(--font-mono);\n}\n\n/* ---- Integration guide drawer: code blocks (dark) ---- */\n.payment-links-page .usage-guide-content .code-content,\n.payment-links-page .usage-guide-content .response-example {\n  background: #1a1a1e;\n  color: #e4e4e7;\n  border-radius: var(--r-md);\n  font-family: var(--font-mono);\n}\n.payment-links-page .usage-guide-content .code-example {\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  overflow: hidden;\n}\n.payment-links-page .usage-guide-content .code-example-header,\n.payment-links-page .usage-guide-content .code-block .code-header {\n  background: var(--bg-subtle);\n  border-bottom: 1px solid var(--line);\n}\n.payment-links-page .usage-guide-content .copy-btn {\n  background: var(--bg-surface);\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-sm);\n  color: var(--ink-secondary);\n}\n.payment-links-page .usage-guide-content .endpoint {\n  font-family: var(--font-mono);\n  color: var(--ink);\n}\n.payment-links-page .usage-guide-content .method.post {\n  background: var(--info-soft);\n  color: var(--info);\n}\n.payment-links-page .usage-guide-content .param-name {\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n  font-family: var(--font-mono);\n}\n.payment-links-page .usage-guide-content .param-required {\n  color: var(--err);\n}\n.payment-links-page .usage-guide-content .param-optional {\n  color: var(--ink-muted);\n}\n.payment-links-page .usage-guide-content .security-item {\n  background: var(--bg-subtle);\n  border-radius: var(--r-md);\n}\n.payment-links-page .usage-guide-content .guide-section-header h3 {\n  color: var(--ink);\n  font-weight: 700;\n}\n.payment-links-page .usage-guide-content .guide-section-header svg {\n  color: var(--accent);\n}\n.payment-links-page .usage-guide-content .step-number {\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n}\n\n/* ---- Confirm modal (delete/revoke) ---- */\n.payment-links-page .confirm-modal {\n  background: var(--bg-surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-lg);\n  box-shadow: var(--sh-pop);\n}\n\n/* ---- Session drawer tx items ---- */\n.payment-link-detail-page .session-transaction-item {\n  border: 1px solid var(--line);\n  border-radius: var(--r-md);\n  background: var(--bg-subtle);\n}\n.payment-link-detail-page .tx-value.mono,\n.payment-link-detail-page .detail-value.mono {\n  font-family: var(--font-mono);\n}\n.payment-link-detail-page .metadata-block {\n  background: #1a1a1e;\n  color: #e4e4e7;\n  border-radius: var(--r-md);\n  font-family: var(--font-mono);\n}\n\n/* ─── Tablet (≤991px) ──────────────────────────────────────────────────────── */\n@media (max-width: 991px) {\n  /* Page header: wrap header actions so the doc-link button doesn't overflow */\n  .payment-links-page .page-header {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .payment-links-page .header-actions {\n    flex-wrap: wrap;\n    gap: 8px;\n    width: 100%;\n  }\n\n  /* Stats row: 2 items per row on tablet */\n  .payment-links-page .stats-row {\n    flex-wrap: wrap;\n  }\n\n  .payment-links-page .stats-row .stat-item {\n    flex: 1 1 calc(50% - 8px);\n    min-width: 120px;\n  }\n\n  /* Detail header: allow stacking when status badge + title are side by side */\n  .payment-link-detail-page .detail-header {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n}\n\n/* ─── Mobile (≤576px) ─────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  /* ── Page root: prevent horizontal scroll ── */\n  .payment-links-page,\n  .payment-link-detail-page {\n    min-width: 0;\n    overflow-x: hidden;\n  }\n\n  /* ── Page header: stack title + actions vertically ── */\n  .payment-links-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n\n  .payment-links-page .page-header h1 {\n    font-size: 1.25rem;\n  }\n\n  .payment-links-page .page-header p {\n    font-size: 0.8125rem;\n  }\n\n  .payment-links-page .header-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n    width: 100%;\n  }\n\n  /* Merchant filter: full-width on mobile */\n  .payment-links-page .merchant-filter {\n    width: 100%;\n    min-width: 0;\n    min-height: 44px;\n    box-sizing: border-box;\n  }\n\n  /* View API Docs button: full-width, 44px tap target */\n  .payment-links-page .mode-btn-purple {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n    text-align: center;\n    box-sizing: border-box;\n  }\n\n  /* ── Stats row: single column ── */\n  .payment-links-page .stats-row {\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .payment-links-page .stats-row .stat-item {\n    flex: none;\n    width: 100%;\n    min-height: 44px;\n    padding: 12px 16px;\n  }\n\n  /* Prevent the DataTable overflow:scroll from forcing horizontal page scroll */\n  .payment-links-page .card .data-table-container {\n    overflow-x: auto;\n    max-width: 100%;\n  }\n\n  /* ── Detail page: back button is already 44px-friendly; add padding ── */\n  .payment-link-detail-page .back-btn {\n    min-height: 44px;\n    padding: 10px 0;\n  }\n\n  /* ── Detail header: stack left+right vertically ── */\n  .payment-link-detail-page .detail-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .payment-link-detail-page .detail-title {\n    font-size: 1.25rem;\n    word-break: break-word;\n  }\n\n  /* ── Page header inside detail views ── */\n  .payment-link-detail-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n\n  .payment-link-detail-page .page-header h1 {\n    font-size: 1.25rem;\n  }\n\n  /* \"Create Payment Link\" button in the payment-links detail view */\n  .payment-link-detail-page .page-header .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Info cards row: force single column ── */\n  .payment-link-detail-page .info-cards-row,\n  .payment-links-page .info-cards-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  /* Code values inside info-cards wrap rather than overflow */\n  .info-card-content code {\n    font-size: 11px;\n    word-break: break-all;\n    overflow-x: hidden;\n  }\n\n  /* ── Stats row in detail view (Transaction counts) ── */\n  .payment-link-detail-page .stats-row {\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n\n  .payment-link-detail-page .stats-row .stat-item {\n    flex: none;\n    width: 100%;\n    min-height: 44px;\n  }\n\n  /* ── Section title inside card (used inline) ── */\n  .payment-link-detail-page .section-title {\n    font-size: 0.9375rem;\n  }\n\n  /* ── Detail rows: stack key-value vertically when value is long (addresses, hashes) ── */\n  .payment-link-detail-page .detail-row {\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n\n  .payment-link-detail-page .detail-value {\n    text-align: left;\n    word-break: break-all;\n    max-width: 100%;\n  }\n\n  /* ── Session status banner: stack status + amount ── */\n  .session-status-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px 16px;\n  }\n\n  .session-amount-large {\n    font-size: 1.25rem;\n  }\n\n  /* ── Drawer: use dynamic viewport height so the footer (primary action)\n        stays inside the visible viewport when the mobile browser chrome is\n        shown — plain 100vh can push the footer below the fold. ── */\n  .payment-links-page .drawer,\n  .payment-link-detail-page .drawer {\n    height: 100vh;\n    height: 100dvh;\n  }\n\n  /* ── Drawer close button: 44px tap target ── */\n  .drawer-close-btn {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* ── Drawer footer buttons: stack vertically, full width ── */\n  .drawer-footer {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .drawer-footer .btn-primary,\n  .drawer-footer .btn-secondary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Confirm modal → bottom sheet on mobile ── */\n  .confirm-modal {\n    position: fixed;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: none;\n    width: 100%;\n    max-width: 100%;\n    border-radius: 16px 16px 0 0;\n    padding: 24px 20px;\n    padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));\n    animation: pl-sheet-up 0.25s ease-out;\n    max-height: 85dvh;\n    max-height: 85vh;\n    overflow-y: auto;\n    z-index: 1001;\n  }\n\n  @keyframes pl-sheet-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  .confirm-modal-actions {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .confirm-modal-actions button {\n    flex: none;\n    width: 100%;\n    min-height: 44px;\n  }\n\n  /* ── API key cell: wrap key + icon buttons ── */\n  .api-key-cell {\n    flex-wrap: wrap;\n    gap: 4px;\n    max-width: 100%;\n  }\n\n  .api-key-cell .api-key-value {\n    word-break: break-all;\n    font-size: 11px;\n    min-width: 0;\n    flex: 1 1 100%;\n  }\n\n  /* Action icon buttons: ensure 44px tap target */\n  .action-icon-btn {\n    min-width: 36px;\n    min-height: 36px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* ── Security table in guide drawer: horizontal scroll rather than breaking layout ── */\n  .security-table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n  }\n\n  /* ── Code blocks in guide drawer: scroll, don't break page ── */\n  .code-content,\n  .response-example {\n    font-size: 11px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* ── Guide steps: consistent padding ── */\n  .guide-section {\n    padding: 16px;\n  }\n\n  .guide-step {\n    gap: 12px;\n  }\n\n  /* ── Empty payments section: reduce padding ── */\n  .empty-payments-section {\n    padding: 24px 16px;\n  }\n\n  .empty-payments-section .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Session transaction items in drawer: comfortable tap/read areas ── */\n  .session-transaction-item {\n    padding: 12px;\n  }\n\n  .tx-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  /* ── Session detail: mono values wrap ── */\n  .detail-value.mono {\n    word-break: break-all;\n    font-size: 11px;\n  }\n\n  /* ── \"View Transactions\" button in payment link detail ── */\n  .detail-section .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
